import React from "react";

function Footer() {
  return (
    <section className="footer-section">
        <p className="footer-p">PASCAL CORREA ©2023</p>
    </section>
  );
}

export default Footer;